<template>
    <section class="section">
        <div class="container">
            <div class="columns is-centered bottom-margin-fix" style="margin: 0;">
                <div class="box column is-one-third">
                    <div class="content">
                        <h2>Register</h2>
                    </div>
                    <form  v-on:submit.prevent>
                        <b-field label="First name">
                            <b-input v-model.trim="registerForm.firstName" type="text" placeholder="First name" id="firstName"></b-input>
                        </b-field>
                        <b-field label="Last name">
                            <b-input v-model.trim="registerForm.lastName" type="text" placeholder="Last name" id="lastName"></b-input>
                        </b-field>
                        <b-field label="Email">
                            <b-input v-model.trim="registerForm.email" type="email" placeholder="Email address" id="email"></b-input>
                        </b-field>
                        <b-field label="Phone">
                            <b-input v-model.trim="registerForm.phone" type="phone" placeholder="Phone number" id="phone"></b-input>
                        </b-field>
                        <b-field label="Company">
                            <b-input v-model.trim="registerForm.company" type="text" placeholder="Company name" id="companyName"></b-input>
                        </b-field>
                        <hr>
                        <b-field label="Password">
                            <b-input v-model.trim="registerForm.password" type="password" placeholder="Your password" id="password"></b-input>
                        </b-field>
                        <b-message size="is-small">
                            Please choose a password longer than 6 characters. 
                        </b-message>    
                        <b-field label="Confirm password">
                            <b-input v-model.trim="confirmedPassword" @keyup.enter="registerUser" type="password" placeholder="Confirm your password" id="confirmPassword"></b-input>
                        </b-field>
                        <hr>
                        <div class="field">
                            <b-checkbox v-model="registerForm.termsAccepted">
                                I agree to the <a href="#" target="_blank">Terms & Conditions</a> and <a href="#" target="_blank">Privacy Policy</a>.
                            </b-checkbox>
                        </div>
                        <div class="field">
                            <b-checkbox v-model="registerForm.disclaimerAccepted">
                                I understand this is early access and the platform is subject to constant change.
                            </b-checkbox>
                        </div>
                        <b-field class="register-button">
                            <b-button :disabled="!canSubmit" type="submit" @click="registerUser" :loading="isLoading" class="button is-primary">Create an account</b-button>
                        </b-field>
                        <hr>
                        <b-field class="login-link">
                            <router-link to="/login">
                                <p>Go back to login.</p>
                            </router-link>
                        </b-field>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

export default {
    data: function() {
        return {
            registerForm: {
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                company: "",
                password: "",
                termsAccepted: false,
                disclaimerAccepted: false
            },
            confirmedPassword: ""
        }
    },
    components: {
    },
    computed: {
        canSubmit: function() {
            // Manual validation
            if (
                this.registerForm.firstName != "" && 
                this.registerForm.lastName != "" &&
                this.registerForm.email != "" &&
                this.registerForm.phone != "" &&
                this.registerForm.company != "" &&
                this.registerForm.password != "" &&
                this.registerForm.termsAccepted != false &&
                this.registerForm.disclaimerAccepted != false
            ) {
                return true;
            } else {
                return false;
            }
        },
        isLoading() {
            return this.$store.state.loading;
        }
    },
    methods: {
        check: function() {
            console.log(this.canSubmit);
        },
        registerUser: function() {
            var createdDate = new Date().toLocaleDateString();
            this.$store.dispatch("register", {
                firstName: this.registerForm.firstName,
                lastName: this.registerForm.lastName,
                email: this.registerForm.email,
                phone: this.registerForm.phone,
                company: this.registerForm.company,
                password: this.registerForm.password,
                termsAccepted: this.registerForm.termsAccepted,
                disclaimerAccepted: this.registerForm.disclaimerAccepted,
                createdDate: createdDate
            });
        }
    }
}
</script>

<style scoped>
.box {
    margin-top: 10vh;
    margin-left: 2%;
    margin-right: 2%;
    margin-bottom: 10vh;
    padding: 40px;
}
.register-button {
    margin-top: 7%;
}
.bottom-margin-fix {
    padding-bottom: 50px;
}
</style>